export const tableFrCATranslations = {
  editMode: "Mode d'édition :",
  emptyTableMessage: "Rien à voir ici… pour l'instant !",
  columns: "Colonnes",
  toggleColumnVisibility: "Basculer la visibilité des colonnes",
  tableActions: "Actions du tableau",
  filterTable: "Filtrer le tableau",
  filterClear: "Effacer",
  textOperatorIs: "est",
  textOperatorIsNot: "n'est pas",
  textOperatorIsAnyOf: "est l'un de",
  textOperatorIsNotAnyOf: "n'est aucun de",
  dateOperatorEq: "Est exactement",
  dateOperatorGt: "Est après",
  dateOperatorGte: "Est le ou après",
  dateOperatorLt: "Est avant",
  dateOperatorLte: "Est le ou avant",
  numericOperatorEq: "Est égal à",
  numericOperatorGt: "Est supérieur à",
  numericOperatorGte: "Est supérieur ou égal à",
  numericOperatorLt: "Est inférieur à",
  numericOperatorLte: "Est inférieur ou égal à",
  booleanYes: "Oui",
  booleanNo: "Non",
  compoundFilter: "Filtre composé",
  compoundFilterAnd: "Filtre composé (ET)",
  compoundFilterOr: "Filtre composé (OU)",
  removeFilterNamed: "Retirer le filtre {{label}}",
  removeFilter: "Retirer le filtre",
  removeCompoundFilter: "Retirer le filtre composé",
  toggleCellValue: "Basculer la valeur",
  removeCondition: "Retirer la condition",
  paginationItem: "élément",
  paginationItems: "éléments",
  tableDefaultName: "Tableau de données",
  tableLoading: "Chargement...",
  tableRefresh: "Actualiser",
  tableNewRecord: "Nouvel enregistrement",
  selectAllRows: "Sélectionner toutes les lignes",
  selectRow: "Sélectionner {{row}}",
  rowLabelFallback: "la ligne {{number}}",
  rowActionName: "{{action}} : {{row}}",
  rowMenuName: "Actions pour {{row}}",
  rowsSelectedVisible: "{{count}} ligne(s) sélectionnée(s)",
  rowsSelectedOne: "1 ligne sélectionnée",
  rowsSelectedMany: "{{count}} lignes sélectionnées",
  rowSelectedOne: "Ligne sélectionnée : {{row}}. 1 ligne sélectionnée.",
  rowSelectedMany:
    "Ligne sélectionnée : {{row}}. {{count}} lignes sélectionnées.",
  rowDeselectedOne: "Ligne désélectionnée : {{row}}. 1 ligne sélectionnée.",
  rowDeselectedMany:
    "Ligne désélectionnée : {{row}}. {{count}} lignes sélectionnées.",
  rowDeselectedNone:
    "Ligne désélectionnée : {{row}}. Aucune ligne sélectionnée.",
  sortByColumn: "Trier par {{column}}",
  sortStateAscending: "Trié par ordre croissant",
  sortStateDescending: "Trié par ordre décroissant",
  sortStateNone: "Non trié",
  sortedAscending: "Trié par {{column}}, ordre croissant",
  sortedDescending: "Trié par {{column}}, ordre décroissant",
  sortCleared: "Tri retiré",
  pagination: "Pagination",
  paginationPrev: "précédent",
  paginationNext: "suivant",
  paginationPreviousName: "Page précédente, page {{page}}",
  paginationNextName: "Page suivante, page {{page}}",
  paginationPreviousEdgeName: "Page précédente",
  paginationNextEdgeName: "Page suivante",
  paginationSummary: "{{count}} {{items}} | Page {{current}} sur {{total}}",
  paginationRange:
    "Page {{current}} sur {{total}}, affichage de {{from}} à {{to}} sur {{count}}",
  emptyTableAnnouncement: "Aucune ligne à afficher",
  columnShown: "Colonne {{column}} affichée",
  columnHidden: "Colonne {{column}} masquée",
  cellEditLabel: "Modifier {{column}} pour {{row}}",
  cellEditStartImmediate:
    "Modification de {{column}}. Les changements sont enregistrés immédiatement.",
  cellEditStart:
    "Modification de {{column}}. Entrée pour valider, Échap pour annuler.",
  cellEditCommitted: "{{column}} défini à {{value}}",
  cellEditUnchanged: "Valeur de {{column}} inchangée",
  cellEditCancelled: "Modification annulée. Valeur de {{column}} rétablie.",
  selectAnOption: "Sélectionnez une option...",
  selectionCleared: "Sélection effacée",
};
